import type { Essentials } from '../../../../../models';
import { queryTagApp } from '../../../../../services/tags-apps';
import {
  SUPPORTED_IN_EDITOR_X_TAG_ID,
  SUPPORTED_IN_STUDIO_TAG_ID,
} from './constants';

export async function isAppSupportedInResponsiveEditors({
  httpClient,
  rpcClient,
  appId,
}: {
  httpClient: Essentials['httpClient'];
  rpcClient?: Essentials['rpcClient'];
  appId: string;
}) {
  const { tagApps = [] } = await queryTagApp({
    httpClient,
    rpcClient,
    payload: {
      query: {
        filter: {
          appId,
          tagId: {
            $in: [SUPPORTED_IN_STUDIO_TAG_ID, SUPPORTED_IN_EDITOR_X_TAG_ID],
          },
        },
      },
    },
  });

  return {
    supportedInEditorX: tagApps.some(
      (tagApp) => tagApp.tagId === SUPPORTED_IN_EDITOR_X_TAG_ID,
    ),
    supportedInStudio: tagApps.some(
      (tagApp) => tagApp.tagId === SUPPORTED_IN_STUDIO_TAG_ID,
    ),
  };
}
